module.exports = __webpack_public_path__ + "img/setIcon1.855cab56.png";